import * as React from 'react';

import AppsIcon from '@mui/icons-material/Apps';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';

import { track } from '@hbf/analytics';

import { AnalyticsEvent } from '@kamernet/core/Analytics/types';
import { useIntl } from '@kamernet/core/Intl';

import { ListingsContext } from '@kamernet/modules/Listing/context/ListingsContext';
import { useFilterStateDispatcher } from '@kamernet/modules/Listing/hooks/useFilterStateDispatcher';
import { SearchView } from '@kamernet/modules/Listing/types';

import styles from './ToggleView.module.css';

export const ToggleView = () => {
  const { T } = useIntl();
  const { filterStateDispatcher } = useFilterStateDispatcher();
  const { listingsState } = ListingsContext.useContext();
  const [viewType, setViewType] = React.useState<SearchView>(
    listingsState.filterResult.filters.searchview || SearchView.List,
  );
  const handleViewChange = React.useCallback(
    (_: React.SyntheticEvent, selectedView: SearchView) => {
      if (selectedView) {
        track(AnalyticsEvent.ClickedChangeView, {
          name: selectedView === SearchView.List ? 'list view' : 'map view',
        });

        setViewType(selectedView);
        filterStateDispatcher({
          ...listingsState.filterResult.filters,
          searchview: selectedView,
        });
      }
    },
    [filterStateDispatcher, listingsState.filterResult.filters],
  );
  const controlProps = {
    value: viewType,
    onChange: handleViewChange,
    exclusive: true,
  };
  return (
    <ToggleButtonGroup
      {...controlProps}
      value={viewType}
      className={styles.root}
    >
      <ToggleButton value={SearchView.List}>
        <AppsIcon />
        <Typography variant="body3">
          {T('LBL_SEARCHROOMS_SWITCH_TILE_VIEW')}
        </Typography>
      </ToggleButton>

      <ToggleButton value={SearchView.Map}>
        <LocationOnOutlinedIcon />
        <Typography variant="body3">
          {T('LBL_SEARCHROOMS_SWITCH_MAP_VIEW')}
        </Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
